import { render, staticRenderFns } from "./InjectionsNavBarComponent.vue?vue&type=template&id=4c7c3de8&"
import script from "./InjectionsNavBarComponent.vue?vue&type=script&lang=js&"
export * from "./InjectionsNavBarComponent.vue?vue&type=script&lang=js&"
import style0 from "./InjectionsNavBarComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports